/**
 * Title-cases a string, lower-casing everything it does not raise.
 *
 * @param {String} providedString - The string to capitalize.
 * @param {Boolean} all - (Optional). Raise every word, or only the first. Default = true.
 *
 * @returns {String|null} The capitalized string, or null if it was not a non-empty string.
 */

export default function capitalize(providedString, all = true) {
  if (!providedString || typeof providedString !== 'string') return null;

  const lowered = providedString.toLowerCase();

  // Without the `g` flag `replace` raises the first word only, which is what `all: false` asks for.
  return all
    ? lowered.replace(/\b[a-z]/g, (letter) => letter.toUpperCase())
    : lowered.replace(/\b[a-z]/, (letter) => letter.toUpperCase());
}
